import { createPortal } from 'react-dom'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import { useModal } from '../hooks'
import { useT } from '../i18n'

import { IconButton } from './Button'
import type { DialogProps } from './Overlay.types'

export function Dialog({
  title,
  onClose,
  children,
  footer,
  wide,
}: DialogProps) {
  const { t } = useT()
  const ref = useModal(onClose)

  return createPortal(
    <div
      className="overlay"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        ref={ref}
        className={`dialog ${wide ? 'dialog--wide' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        tabIndex={-1}
      >
        <div className="dialog__header">
          <h2 className="dialog__title">{title}</h2>
          <IconButton icon={faXmark} label={t.common.close} onClick={onClose} />
        </div>
        <div className="dialog__body">{children}</div>
        {footer && <div className="dialog__footer">{footer}</div>}
      </div>
    </div>,
    document.body,
  )
}

export function Drawer({ title, onClose, children, footer }: DialogProps) {
  const { t } = useT()
  const ref = useModal(onClose)

  return createPortal(
    <div
      className="overlay drawer-overlay"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        ref={ref}
        className="drawer"
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        tabIndex={-1}
      >
        <div className="dialog__header">
          <h2 className="dialog__title">{title}</h2>
          <IconButton icon={faXmark} label={t.common.close} onClick={onClose} />
        </div>
        <div className="dialog__body">{children}</div>
        {footer && <div className="dialog__footer">{footer}</div>}
      </div>
    </div>,
    document.body,
  )
}
